import React, { useEffect, useRef, useState } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';
import axios from "axios";
import { Constants } from "../../lib/const/constants";
import ReactPaginate from 'react-paginate';
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiChevronLeft, FiChevronRight, FiUploadCloud, FiFileText } from 'react-icons/fi';
import { ToastContainer, toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import { encryptPayload } from "../../utils/encryption";

function Membership() {
  const navigate = useNavigate();
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [kycLoading, setkycLoading] = useState(false);
  const [loadingid, setloadingid] = useState(0);
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [userAttachment, setuserAttachment] = useState([]);
  const userFileInputRef = useRef(null);
  const [edituserAttachment, setedituserAttachment] = useState([]);
  const [userId, setuserId] = useState();
  const [membershipNo, setmembershipNo] = useState();
  const [membershipDocuments, setmembershipDocuments] = useState([]);
  const [docLoading, setDocLoading] = useState(false);
  useEffect(() => {
    getData()
  }, [])
  const getData = async () => {
    setLoading(true);
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    await axios.get(Constants.BASE_URL + 'API-FX-214-LIST-MEMBERSHIP-COMPLIANCE?login_id=' + staff_login_id, {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY
      }
    }).then(resp => {
      setMemberships(resp.data.workspaces)
      setLoading(false)
    }).catch(err => {
      console.log(err.response.data);
      setLoading(false)
    })
  }

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchText(query);
  };
  function Items({ currentItems }) {
    Items.propTypes = {
      currentItems: PropTypes.any,
    };
    async function onbehalfOf(user_id) {

      setLoading(true);
      setAsyncData();
      setAsyncData("staff_login_id", sessionStorage.getItem('staff_login_id'))
      setAsyncData("staff_login_full_name", sessionStorage.getItem('login_full_name'))
      setAsyncData("staff_login_email", sessionStorage.getItem('login_email'))
      setAsyncData("staff_login_phone", sessionStorage.getItem('login_phone'))
      setAsyncData("staff_login_date_of_birth", sessionStorage.getItem('login_date_of_birth'))
      setAsyncData("staff_login_country_code", sessionStorage.getItem('login_country_code'))
      setAsyncData("staff_login_country_id", sessionStorage.getItem('login_country_id'))
      setAsyncData("staff_login_country_name", sessionStorage.getItem('login_country_name'))
      setAsyncData("staff_login_nationality", sessionStorage.getItem('login_nationality'))
      setAsyncData("staff_login_token", sessionStorage.getItem('staff_login_token'))
      setAsyncData("staff_kyc_submitted", sessionStorage.getItem('kyc_submitted'));

      const payload = {
        user_id: user_id,
        platform: 'web',extraParamValidation: 'trustedfromweb'
      };

      const encPayload = await encryptPayload(payload)

      await axios.post(Constants.BASE_URL + 'API-FX-223-LOGIN-BY-USERID', encPayload, {
        headers: {
          'fx_key': Constants.SUBSCRIPTION_KEY,
        }
      }).then(resp => {
        // console.log(JSON.stringify(resp.data));
        loadAppDefault();
        loadcountries();


        setAsyncData("login_id", JSON.stringify(resp.data.data.id))
        setAsyncData("login_full_name", resp.data.data.full_name)
        setAsyncData("login_email", resp.data.data.email)
        setAsyncData("login_phone", resp.data.data.phone)
        setAsyncData("login_date_of_birth", resp.data.data.date_of_birth)
        setAsyncData("login_country_code", resp.data.data.country_code)
        setAsyncData("login_country_id", JSON.stringify(resp.data.data.country_id))
        setAsyncData("login_country_name", resp.data.data.country_name)
        setAsyncData("login_nationality", resp.data.data.nationality)
        setAsyncData("login_registration_step", resp.data.data.registration_step)
        setAsyncData("login_is_banking_user", JSON.stringify(resp.data.data.is_banking_user))
        setAsyncData("login_status", resp.data.data.status)
        setAsyncData("login_yoti_status", resp.data.data.yoti_status)
        setAsyncData("login_workspaces", JSON.stringify(resp.data.data.workspaces))
        setAsyncData("login_workspaces_id", JSON.stringify(resp.data.data.workspaces[0].id))
        setAsyncData("login_token", JSON.stringify(resp.data.token))
        // setAsyncData("login_address", JSON.stringify(resp.data.data.addresses[0].address + resp.data.data.addresses[0].street))
        // setAsyncData("login_postcode", JSON.stringify(resp.data.data.addresses[0].postcode))
        // setAsyncData("login_city", JSON.stringify(resp.data.data.addresses[0].city))
        console.log(resp.data.default_bank);
        if (resp.data.default_bank.length > 0 && resp.data.default_bank[0] != 'CC as Service') {
          setAsyncData("defaultBank", resp.data.default_bank[0])
          setAsyncData("clearBankCustomerId", resp.data.clear_bank_data[0].customer_id)
          setAsyncData("clearBankCustomerBankCode", resp.data.clear_bank_data[0].meta.bank[0].BankCode)
          setAsyncData("clearBankCustomerIBAN", resp.data.clear_bank_data[0].meta.bank[0].IBAN)
          setAsyncData("clearBankCustomerWalletId", resp.data.clear_bank_data[0].meta.bank[0].WalletId)
          setAsyncData("clearBankCustomerSWIFTCode", resp.data.clear_bank_data[0].meta.bank[0].SWIFTCode)
          setAsyncData("clearBankCustomerAccountName", resp.data.clear_bank_data[0].meta.bank[0].AccountName)
          setAsyncData("clearBankCustomerWalletNumber", resp.data.clear_bank_data[0].meta.bank[0].WalletNumber)
          setAsyncData("clearBankCustomerSortCode", resp.data.clear_bank_data[0].meta.bank[0].sortCode)
          setAsyncData("clearBankCustomerServiceProviderAccountId", resp.data.clear_bank_data[0].meta.bank[0].ServiceProviderAccountId)
        }
        else {
          setAsyncData("defaultBank", "CC as Service")
          setAsyncData("clearBankCustomerId", "")
        }
        setAsyncData("kyc_submitted", "true");
        setLoading(false);
        setAsyncData("login_id", JSON.stringify(resp.data.data.id))
        console.log("rrrrr" + resp.data.data.id);
        if(resp.data.data.workspaces[0].type=='individual')
        navigate("/SendMoneyTab",{state:{qr_login_completed:1}})
        else
        navigate("/",{state:{qr_login_completed:1}})
        location.reload();

        setLoading(false);
      }).catch(err => {
        console.log(JSON.stringify(err.response.data));
        setLoading(false);
      })

    }


    const loadcountries = async () => {
      await axios.get(Constants.BASE_URL + "API-FX-102-Country", {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY
        }
      }).then(response => {
        setAsyncData('countries', JSON.stringify(response.data.data));
      }).catch(error => {
        console.log("countr" + error.response.data);
      })
    }
    const loadAppDefault = async () => {
      await axios.get(Constants.BASE_URL + "API-FX-100-App", {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY
        }
      }).then(response => {
        setAsyncData('transfer_reasons', JSON.stringify(response.data.data.transfer_reasons));
      }).catch(error => {
        console.log("app" + error.response);
      })
    }
    const setAsyncData = async (key, value) => {
      sessionStorage.setItem(key, value);
    }
    return (
      <>
        <table className='w-full bg-[#ffffff] text-[13px] text-[#1F2937]' >
          {currentItems &&
            currentItems.map((item, index) => {
            const bankMeta = item.clearbank_meta ? JSON.parse(item.clearbank_meta) : null;
              return (
                <>
                  {index == 0 &&
                    <thead className="bg-[#F3F4F6] border-y border-[#E5E7EB]">
                      <tr className="text-[13px] font-semibold text-[#111827]">
                        <th scope="col" className="px-4 py-3 text-left whitespace-nowrap">Membership.No</th>
                        <th scope="col" className="px-4 py-3 text-center">Name</th>
                        <th scope="col" className="px-4 py-3 text-center">Email</th>
                        <th scope="col" className="px-4 py-3 text-center">Phone</th>
                        <th scope="col" className="px-4 py-3 text-center whitespace-nowrap">Account_Type</th>
                        <th scope="col" className="px-4 py-3 text-center whitespace-nowrap">Account Details</th>
                        <th scope="col" className="px-4 py-3 text-center">Rekyc</th>
                        <th scope="col" className="px-4 py-3 text-center text-[#D92D20]">Action</th>
                      </tr>
                    </thead>}
                  {
                     kycLoading && loadingid == item.admin_id ?
                      <tr key={item.admin_id} className="border-b border-[#E5E7EB]">
                        <td colSpan={8} className="px-4 py-6 text-center text-[#6B7280]">loading...</td>
                      </tr>
                      :
                      <tr key={item.admin_id} className="border-b border-[#E5E7EB] last:border-b-0 hover:bg-[#F9FAFB] transition-colors">
                        <th scope="row" className="px-4 py-5 font-normal text-left whitespace-nowrap">{item.memershipNo}</th>
                        <td className="px-4 py-5 max-w-[180px] leading-snug">{item.name}</td>
                        <td className="px-4 py-5 text-center break-all">{item.email}</td>
                        <td className="px-4 py-5 text-center whitespace-nowrap">{item.phone}</td>
                        <td className="px-4 py-5 text-center capitalize">{item.type}</td>
                        <td className="px-4 py-5 whitespace-nowrap leading-7">
                          Account No : {bankMeta?.bank?.[0]?.WalletNumber || "-"}<br />
                          Sort Code : {bankMeta?.bank?.[0]?.sortCode || "-"}<br />
                          IBAN : {bankMeta?.bank?.[0]?.IBAN || "-"}
                        </td>
                        <td className="px-4 py-5 text-center">
                          {item.is_re_kyc==1 ? <span className="px-2 py-1 rounded-full bg-[#FEF3C7] text-[#92400E] text-xs font-medium">Initiated</span> : ""}
                        </td>
                        <td className="px-4 py-5 text-center">
                          <Menu>
                            <MenuButton className="p-1.5 rounded-md text-[#374151] hover:bg-[#F3F4F6] focus:outline-none"><HiOutlineCog6Tooth className="text-lg" /></MenuButton>
                            <MenuItems anchor="bottom end" className="mt-2 min-w-[180px] rounded-lg bg-white border border-[#E5E7EB] shadow-lg py-1 text-sm text-[#1F2937] focus:outline-none z-40">
                              {/* <MenuItem key="edit" className="px-6 py-1 hover:bg-none">
                            <a className="block" href="javascript:void(0);" onClick={()=>navigate('/memberships/show')}>
                              Show
                            </a>
                          </MenuItem> */}
                              {/* <MenuItem key="create_virtual_account" className="px-6 py-3 hover:bg-none bg-[#0B214E]">
                              <a className="block" href="javascript:void(0);" onClick={() => navigate('/userDetails', { state: { account_id: item.customer_id } })}>
                                Create Virtual Account
                              </a>
                            </MenuItem>

                            <MenuItem key="list_accounts" className="px-6 py-3 hover:bg-none bg-[#0B214E]">
                              <a className="block" href="javascript:void(0);" onClick={() => navigate('/ListUsers', { state: { account_id: item.customer_id } })}>
                                List Accounts
                              </a>
                            </MenuItem>

                            <MenuItem key="fees" className="px-6 py-3 hover:bg-none bg-[#0B214E]">
                              <a className="block" href="javascript:void(0);" onClick={() => navigate('/SetFees', { state: { admin_id: item.admin_id } })}>
                                Fees
                              </a>
                            </MenuItem> */}

                              <MenuItem key="on_behalf_of" className="block px-4 py-2.5 text-left data-[focus]:bg-[#F3F4F6]">
                                <a className="block" href="javascript:void(0);" onClick={() => onbehalfOf(item.admin_id)}>
                                  On Behalf Of
                                </a>
                              </MenuItem>
                              <MenuItem key="on_behalf_of" className="block px-4 py-2.5 text-left data-[focus]:bg-[#F3F4F6]">
                                <a className="block" href="javascript:void(0);" onClick={() => rekyc(item.admin_id, item.sumsub_external_id, item.phone, item.email)}>
                                  Re-KYC
                                </a>
                              </MenuItem>
                              <MenuItem key="on_behalf_of" className="block px-4 py-2.5 text-left data-[focus]:bg-[#F3F4F6]">
                                <a className="block" href="javascript:void(0);" onClick={() => handleShow(item.admin_id, item.memershipNo)}>
                                  Upload Documents
                                </a>
                              </MenuItem>
                            </MenuItems>
                          </Menu>
                        </td>
                      </tr>
                  }
                </>
              )
            })
          }
        </table>
      </>
    );
  }

  const filteredMemberships = memberships.filter((item) => {
    const query = searchText.toLowerCase();

    return (
      item.memershipNo?.toLowerCase().includes(query) ||
      item.name?.toLowerCase().includes(query) ||
      item.email?.toLowerCase().includes(query) ||
      item.phone?.toLowerCase().includes(query) ||
      item.type?.toLowerCase().includes(query)
    );
  });

  function PaginatedItems({ itemsPerPage }) {
    useEffect(() => {
      setItemOffset(0);
    }, [searchText]);

    PaginatedItems.propTypes = {
      itemsPerPage: PropTypes.any,
    };
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filteredMemberships.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filteredMemberships.length / itemsPerPage);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      const newOffset =
        (event.selected * itemsPerPage) % filteredMemberships.length;

      setItemOffset(newOffset);
    };
    return (
      <>
        <Items currentItems={currentItems} />
        <ReactPaginate
          breakLabel="..."
          nextLabel={<span className="flex items-center gap-1">Next <FiChevronRight /></span>}
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel={<span className="flex items-center gap-1"><FiChevronLeft /> Previous</span>}
          renderOnZeroPageCount={null}
          className="flex justify-end items-center gap-2 px-4 py-4 border-t border-[#E5E7EB] text-[13px]"
          pageLinkClassName="flex items-center justify-center min-w-[32px] h-8 px-2 rounded-md border border-[#E5E7EB] text-[#374151] hover:bg-[#F3F4F6]"
          activeLinkClassName="!bg-[#2F6FDE] !border-[#2F6FDE] !text-white"
          previousLinkClassName="flex items-center h-8 px-3 rounded-md border border-[#E5E7EB] text-[#374151] font-medium hover:bg-[#F3F4F6]"
          nextLinkClassName="flex items-center h-8 px-3 rounded-md border border-[#E5E7EB] text-[#111827] font-medium hover:bg-[#F3F4F6]"
          breakLinkClassName="flex items-center justify-center w-8 h-8 text-[#6B7280]"
          disabledLinkClassName="!text-[#9CA3AF] !cursor-not-allowed hover:!bg-transparent"
        />
      </>
    );
  }

  const getErrorMessage = (err, fallback) => {
    const data = err.response?.data;
    if (typeof data === 'string' && data) return data;
    return data?.message || data?.error || err.message || fallback;
  };

  const sendSms = async (mobile) => {
    if (!mobile) {
      toast.error('Mobile number not available for this user.');
      return;
    }
    await axios.post(Constants.BASE_URL + 'API-FX-169-SendAgentSms', { mobile: mobile }, {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY,
      }
    }).then(resp => {
      toast.success(resp.data?.message || 'SMS sent successfully');
    }).catch(err => {
      toast.error(getErrorMessage(err, 'Failed to send SMS'));
    })
  }

  const sendEmail = async (email) => {
    if (!email) {
      toast.error('Email not available for this user.');
      return;
    }
    await axios.post(Constants.BASE_URL + 'API-FX-170-SendAgentEmail', { email: email }, {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY,
      }
    }).then(resp => {
      toast.success(resp.data?.message || 'Email sent successfully');
    }).catch(err => {
      toast.error(getErrorMessage(err, 'Failed to send email'));
    })
  }

  const rekyc = async (user_id, user_mobile, phone, email) => {
    if (confirm('Please confirm to reinitiate the kyc.')) {
      setkycLoading(true)
      setloadingid(user_id)
      const encryptedPayload = await encryptPayload({
        "kyc_type": "selfie",
        "user_mobile": user_mobile,
        "platform": 'web',
        "extraParamValidation": 'trustedfromweb'
      });
      await axios.post(Constants.BASE_URL + "API-FX-228-RE-KYC", encryptedPayload, {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
        }
      }).then(resp => {
        resp
        updatestatusinuser(user_id)
        sendSms(phone)
        sendEmail(email)
      }).catch(err => {
        console.log(err.response);
        if (err.response.status == 400)
          toast.error("User not found")
        else
          if (err.response.status == 409)
            toast.error("Previous KYC is still pending")
        setkycLoading(false)
      })
    }
  }
  const updatestatusinuser = async (user_id) => {
    const login_token = sessionStorage.getItem('staff_login_token');
    const encryptedPayload = await encryptPayload({
      "user_id": user_id,
      "is_re_kyc": 1,
      "platform": 'web',
      "extraParamValidation": 'trustedfromweb'
    });
    await axios.post(Constants.BASE_URL + 'API-FX-226-REKYC', encryptedPayload, {
      headers: {
        Authorization: 'Bearer ' + JSON.parse(login_token),
        fx_key: Constants.SUBSCRIPTION_KEY
      }
    }).then(resp => {
      toast.success(resp.data.status)
      setkycLoading(false)
    }).catch(err => {
      console.log(err.response.data);
      setkycLoading(false)
    })
  }
  const handleClose = () => {
    setShow(false);
    // setLoading(false);
    setEdit(false);
  };
  const handleShow = (user_id, memershipNo) => {
    setShow(true);
    setuserId(user_id);
    setmembershipNo(memershipNo)
  };
  const handleUserFileChange = async (event) => {
    const files = event.target.files;
    const updatedFiles = [];

    for (let i = 0; i < files.length; i++) {
      updatedFiles.push({
        file: null,
        name: files[i].name,
      });
    }

    setuserAttachment(updatedFiles);

    const filePromises = [];
    for (let i = 0; i < files.length; i++) {
      filePromises.push(convertFileToBase64(files[i]));
    }

    // Convert files to Base64 and update the state
    try {
      const base64Files = await Promise.all(filePromises);
      const completedFiles = base64Files.map((file, index) => ({
        file: file.file, // Base64 string
        name: updatedFiles[index].name, // Original file name
        preview: URL.createObjectURL(files[index]), // Preview URL for immediate display
      }));
      setedituserAttachment(completedFiles);
    } catch (error) {
      console.error('Error converting files to Base64:', error);
    }
  };
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      var extension = (file.name).split('.');
      reader.onload = () => resolve({ 'file': reader.result, 'extension': extension[extension.length - 1] });
      reader.onerror = (error) => reject(error);
    });
  };
  const saveData = async () => {
    setDocLoading(true)
    const encryptedPayload = await encryptPayload({
      user_attachments: edituserAttachment,
      user_id: userId,
      membership_no: membershipNo,
      platform: 'web',
      extraParamValidation: 'trustedfromweb'
    });
    await axios.post(Constants.BASE_URL + 'API-FX-227-UPLOAD-MEMBERSHIP-DOCUMENTS', encryptedPayload, {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY,
      },
    }).then(resp => {
      console.log(resp.data);
      getDocuments();
      setDocLoading(false)
      setEdit(false)
      setuserAttachment([])
    }).catch(err => {
      console.log(err.response.data);
      setDocLoading(false)
    })
  }
  const getDocuments = async () => {
    setDocLoading(true)
    const encryptedPayload = await encryptPayload({
      user_id: userId,
      platform: 'web',
      extraParamValidation: 'trustedfromweb'
    });
    await axios.post(Constants.BASE_URL + 'API-FX-228-GET-MEMBERSHIP-DOCUMENTS', encryptedPayload, {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY,
      },
    }).then(resp => {
      setmembershipDocuments(resp.data.documents)
      console.log(membershipDocuments);
      setDocLoading(false)

    }).catch(err => {
      console.log(err.response.data);
      setDocLoading(false)
    })
  }
  useEffect(() => {
    getDocuments()
  }, [userId])
  return (
    <div className="my-2 min-h-full bg-[#F7F8FC] px-2 sm:px-6 py-6">
      <ToastContainer />

      {show &&
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4" onClick={handleClose}>
          <div className="w-full max-w-[440px] max-h-[90vh] overflow-y-auto rounded-xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between px-6 pt-6">
              <div>
                <h2 className="text-lg font-semibold text-[#111827]">Upload Document</h2>
                <p className="mt-1 text-sm text-[#6B7280]">Upload the required document for this membership.</p>
              </div>
              <button onClick={handleClose} className="text-xl text-[#9CA3AF] hover:text-[#374151]">
                <MdClose />
              </button>
            </div>

            <div className="px-6 py-5">
              {docLoading && (<div className="py-10 text-center text-sm text-[#6B7280]">loading...</div>)}

              {!docLoading &&
                <div
                  className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-[#D1D5DB] bg-white px-6 py-8 text-center"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.preventDefault();
                    if (userAttachment.length === 0 && e.dataTransfer.files.length > 0) {
                      setEdit(true);
                      handleUserFileChange({ target: { files: e.dataTransfer.files } });
                    }
                  }}
                >
                  {userAttachment.length > 0 ? (
                    <div className="flex flex-col items-center">
                      <FiFileText className="mb-2 text-4xl text-[#2F6FDE]" />
                      <p className="mb-1 text-sm font-semibold text-[#111827]">
                        {'Document Attached'}
                      </p>
                      <div className="mb-4 space-y-0.5 text-xs text-[#6B7280]">
                        {userAttachment.map((att, i) => <div key={i} className="break-all">{att.name}</div>)}
                      </div>
                      <button
                        className={`rounded-md border px-6 py-2 text-sm font-medium ${userAttachment[0] ? 'border-[#F97316] text-[#F97316] hover:bg-[#FFF7ED] cursor-pointer' : 'border-[#E5E7EB] text-[#9CA3AF] cursor-not-allowed'
                          }`}
                        onClick={() => {
                          if (userAttachment[0]) {
                            window.open(Constants.FILE_PATH_BASE_URL + userAttachment[0], '_blank');
                          }
                        }}
                        disabled={!userAttachment[0]}
                      >
                        View Document
                      </button>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center">
                      <FiUploadCloud className="mb-3 text-4xl text-[#4B5563]" />
                      <p className="text-sm font-semibold text-[#111827]">Drag and drop your file here</p>
                      <p className="my-2 text-xs text-[#6B7280]">or</p>
                      <input
                        type="file"
                        ref={userFileInputRef}
                        onChange={handleUserFileChange}
                        className="hidden"
                        multiple
                      />
                      <button
                        className="rounded-md border border-[#F97316] px-6 py-2 text-sm font-medium text-[#F97316] hover:bg-[#FFF7ED]"
                        onClick={() => {
                          setEdit(true);
                          if (userFileInputRef.current) {
                            userFileInputRef.current.click();
                          }
                        }}
                      >
                        Choose File
                      </button>
                      <p className="mt-3 text-xs text-[#6B7280]">Supported formats: PDF, JPG, PNG</p>
                      <p className="text-xs text-[#6B7280]">Max file size: 5 MB</p>
                    </div>
                  )}
                </div>}

              {!docLoading && membershipDocuments.length > 0 &&
                <div className="mt-5">
                  <p className="mb-2 text-sm font-semibold text-[#111827]">Uploaded Documents</p>
                  <ul className="divide-y divide-[#E5E7EB] rounded-lg border border-[#E5E7EB]">
                    {membershipDocuments.map((membershipDoc, index) => {
                      return (
                        <li key={index} className="flex items-center gap-3 px-3 py-2 text-sm">
                          <span className="w-5 text-[#6B7280]">{index + 1}</span>
                          <FiFileText className="shrink-0 text-[#2F6FDE]" />
                          <a className="truncate text-[#2F6FDE] hover:underline" href={Constants.FILE_PATH_BASE_URL + membershipDoc.fileName} target="_blank" rel="noreferrer">{membershipDoc.fileName}</a>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              }
            </div>

            <div className="flex justify-end gap-3 px-6 pb-6">
              <button onClick={() => {
                setEdit(false);
                handleClose();
              }}
                className="rounded-md border border-[#D1D5DB] px-5 py-2 text-sm font-medium text-[#374151] hover:bg-[#F9FAFB]">
                Cancel
              </button>
              <button onClick={() => saveData()}
                disabled={!edit || userAttachment.length === 0 || docLoading}
                className="rounded-md bg-[#2F6FDE] px-5 py-2 text-sm font-medium text-white hover:bg-[#245BC0] disabled:cursor-not-allowed disabled:bg-[#E5E7EB] disabled:text-[#9CA3AF]">
                Upload
              </button>
            </div>
          </div>
        </div>
      }

      <h1 className="mb-6 text-center text-2xl font-semibold text-[#33438B]">Membership</h1>

      <div className="overflow-hidden rounded-xl bg-white shadow-[0_1px_3px_rgba(16,24,40,0.08)]">
        <div className="flex justify-end px-4 py-4">
          <div className="relative w-full max-w-[360px]">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]" />
            <input
              type="text"
              placeholder="Search By Membership No, Name, Email, Phone, Account Details"
              value={searchText}
              onChange={handleSearch}
              className="w-full rounded-md border border-[#E5E7EB] bg-white py-2 pl-9 pr-3 text-xs text-[#111827] placeholder:text-[#9CA3AF] focus:border-[#2F6FDE] focus:outline-none focus:ring-1 focus:ring-[#2F6FDE]"
            />
          </div>
        </div>
        <div className="relative overflow-x-auto">
          {loading ?
            <div className="px-6 py-10 text-center text-sm text-[#6B7280]">loading...</div>
            :
            <PaginatedItems itemsPerPage={100} />
          }
        </div>
      </div>
      {/* <nav className="flex justify-center my-4">
        <ul className="inline-flex space-x-2 text-sm">
          <li>
            <a href="#"
              className="flex items-center justify-center px-3 h-8 ms-0 text-gray-500 bg-white border rounded-full hover:bg-gray-100">&laquo;</a>
          </li>
          <li>
            <a href="#"
              className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border rounded-full">1</a>
          </li>
          <li>
            <a href="#"
              className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border rounded-full">2</a>
          </li>
          <li>
            <a href="#" aria-current="page"
              className="flex items-center justify-center px-3 h-8 text-custom-sky-blue-500 border rounded-full bg-custom-neutral-900">3</a>
          </li>
          <li>
            <a href="#"
              className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border rounded-full">4</a>
          </li>
          <li>
            <a href="#"
              className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border rounded-full">5</a>
          </li>
          <li>
            <a href="#"
              className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border rounded-full">&raquo;</a>
          </li>
        </ul>
      </nav> */}
    </div>
  )
}

export default Membership